import React from "react"
import TextArea from "./TextArea";
import FormLabel from "./FormLabel";
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
    container: {
        flexDirection: 'column',
        display: 'flex',
        marginBottom: '8px'
    }
})

const RecipeSection = (props) => {
    const {isList, value, name, maxRows} = props
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <FormLabel name={name}/>
            <TextArea 
              type="textfield"
              name={`recipe[${name.toLowerCase()}]`}
              isList={isList}
              value={value}
              maxRows={maxRows}/>
        </div>
    );
}

export default RecipeSection
